module.exports = __webpack_public_path__ + "b-g-bici-logo.efd2c8191709b316c687.png";


//////////////////
// WEBPACK FOOTER
// C:/Biciregistro/workspace/biciregistro - angular/src/assets/images/b-g-bici-logo.png
// module id = ../../../../../src/assets/images/b-g-bici-logo.png
// module chunks = styles